import React from 'react';
import Webcam from "react-webcam";


const videoConstraints = {
  width: 512,
  height: 512,
  facingMode: "user"
};


export default class BCamInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { 
      value: this.props.value || null  ,
      mode:0
    
    };

   
  }

  setRef = webcam => {
    this.webcam = webcam;
  };
  capture = () => {
    const value = this.webcam.getScreenshot();
    //this.props.value=value;
    this.props.onChange(value);
    
    this.setState ({
      value:value,
      mode:0
    })

  };

  showcam = () => {
    
    this.setState ({
      mode:1
    })

  };

  cancel = () => {
    
    this.setState ({
      mode:0
    })

  };


  
  // fired after value props changed
  componentWillReceiveProps(nextProps) {
    
    //console.log('nextProps',nextProps.value);
    try {
      this.value=nextProps.value;
      this.setState({ value: nextProps.value });
    }
    catch(error) {
      console.error(error); 
    }
    
    
  }
  

  render() {
    const {mode}=this.state;
    const{width,height}=this.props;
    const styles = {
      container: {
          width: width,
          height: height
      }
    };
    return (
      <div  >
        { mode==1 &&

          <div className="camcontainer" style={styles.container} width={width} height={height}>
             <Webcam
              audio={false}
              height={height}
              ref={this.setRef}
              screenshotFormat="image/jpeg"
              width={width}
              className="image"
              videoConstraints={videoConstraints}
            />
           
            <div className="middle">
              <button type="button" className="btn btn-primary btn-sm" onClick={this.capture}><i class="fa fa-camera"></i></button>
              <button type="button" className="btn btn-danger btn-sm" onClick={this.cancel}><i class="fa fa-close"></i></button>
            </div>
          </div>
        
        }

        {
          mode ==0 &&
          
          <div className="camcontainer" style={styles.container}>
            {this.state.value!=null &&
              <img src={this.state.value} width={width} height={height}></img>
            }
            {this.state.value==null &&
              <img src="/content/images/noprofile.jpg" width={width} height={height}></img>
            }
             
             
            <div className="middle">
              <button type="button" className="btn btn-success btn-sm" onClick={this.showcam}>تصویر جدید</button>
            </div>
          </div>

        }
       
        
      </div>
    );
  }
}